import { I18n } from "i18n-js";
import ja from "../../../config/locales/i18n-js/ja.json";
import en from "../../../config/locales/i18n-js/en.json";

export const i18n = new I18n();
i18n.store(ja);
i18n.store(en);
i18n.enableFallback = true;
i18n.defaultLocale = "ja";
window.i18n = i18n;
